var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hl-layout-wrapper"},[_c('div',{staticClass:"hl-container"},[_c('div',{staticClass:"hl-content"},[(_vm.pageBackFlag)?_c('AppNavBar',{attrs:{"BackTitle":_vm.pageBackTitle}}):_vm._e(),_c('AppMain'),(!_vm.pageBackFlag)?_c('FootRouter',{attrs:{"tabbarItem":_vm.bottomRoutes}}):_vm._e()],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }